import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconQuestionmarkCircle2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconQuestionmarkCircle2"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM9 7H15V11L13 12.5V14H11V11.5L13 10V9H11V10H9V7ZM13 17V15H11V17H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconQuestionmarkCircle2;
